var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVDrm01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3069_82159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6004 29.459C41.1475 26.2021 42.0549 22.576 42.6156 18.2339",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39953 29.4586C3.87672 24.1471 3.05465 17.8499 2.66113 9.0722C2.61711 8.09649 3.34754 7.25915 4.32054 7.16931C11.0606 6.54579 16.5384 4.88548 21.9398 1.01411C22.5732 0.5604 23.4267 0.5604 24.0601 1.01411C29.4615 4.88548 34.9393 6.54579 41.6794 7.16931C42.6524 7.25915 43.3828 8.09649 43.3388 9.0722C43.2427 11.2258 43.1196 13.2302 42.9525 15.107",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8116 38.9707C16.0532 40.9563 18.7531 42.9382 22.0072 45.0343C22.6118 45.4233 23.3881 45.4233 23.9927 45.0343C27.2469 42.9382 29.9467 40.9563 32.1883 38.9707",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6166 32.5718L44.6595 33.923C45.3342 34.1036 45.5534 34.9517 45.0521 35.4369L43.2013 37.2257C42.7242 37.6875 42.5401 38.3739 42.7225 39.0118L43.4304 41.487C43.6227 42.1581 43.0091 42.7825 42.3343 42.6019L33.4533 40.222C32.4946 39.965 31.9259 38.9794 32.1829 38.0208L32.5369 36.6992",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8163 39.906L37.8242 38.0894",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4631 36.6992L13.817 38.0208C14.074 38.9794 13.5053 39.965 12.5467 40.222L3.6656 42.6019C2.99087 42.7825 2.37724 42.1581 2.5695 41.487L3.27747 39.0118C3.45985 38.3739 3.27567 37.6875 2.7986 37.2257L0.947822 35.4369C0.446494 34.9517 0.665713 34.1036 1.34044 33.923L6.38337 32.5718",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1837 39.906L8.17578 38.0894",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4886 35.8063C29.6583 36.0219 33.8055 36.7829 37.8242 38.0892C38.5618 35.8198 39.2985 33.5503 40.0361 31.2818C40.3506 30.3142 39.7999 29.281 38.8233 28.9988C28.4867 26.0088 17.5132 26.0088 7.17669 28.9988C6.20009 29.281 5.64934 30.3142 5.9638 31.2818C6.70141 33.5503 7.43813 35.8198 8.17575 38.0892C12.7829 36.5915 17.5599 35.8108 22.3441 35.7461",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0586 15.9966V14.5815C18.0586 13.2168 18.612 11.9815 19.506 11.0875C20.3999 10.1936 21.6353 9.64014 23 9.64014C25.7295 9.64014 27.9414 11.8521 27.9414 14.5815V15.9966",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4648 15.9966V14.5815C14.4648 9.86744 18.2859 6.04639 23 6.04639C25.3575 6.04639 27.4904 7.00143 29.0357 8.54584C30.5801 10.0912 31.5352 12.224 31.5352 14.5815V15.9966",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7295 15.9966H31.5351C33.0238 15.9966 34.2304 17.2032 34.2304 18.6919V27.8748",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7695 27.8748V18.6919C11.7695 17.2032 12.9761 15.9966 14.4648 15.9966H20.585",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3069_82159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVDrm01);
export default __webpack_public_path__ + "static/media/vDRM01.148df4cfcc089f138d7804bae193323e.svg";
export { ForwardRef as ReactComponent };